import { toast } from "react-toastify";

export const noop = () => {};

export const err = (err) => toast.error(err.message);
